var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"block":"","loading":_vm.loading,"disabled":_vm.loading,"color":"secondary","x-large":""},on:{"click":_vm.wasClicked}},[_vm._v("Marcar Crise")])}
var staticRenderFns = []

export { render, staticRenderFns }